module.exports = __webpack_public_path__ + "img/clock-icon.07e11b80.svg";